export function responseToDebtStatesProps(Component) {
  // eslint-disable-next-line react/display-name
  return ({ page, isState, state, ...props }) => {
    const { keyTakeaways = '' } = props
    const categoryBreadcrumbs =
      page?.category && page.path !== `${page.category.slug}/`
        ? {
            label: page?.category?.title,
            path: `/l/${page?.category?.slug}`,
          }
        : {
            label: 'Home',
            path: `/`,
          }
    const cityBreadcrumbs = !isState
      ? {
          label: `${state.state}`,
          path: `/debt-consolidation-near-me/${state.slug}`,
        }
      : {
          label: props.title,
          path: page.path,
        }
    const componentProps = {
      ...props,
      state,
      pageSlug: page.path,
      breadcrumbs: [{ ...categoryBreadcrumbs }, cityBreadcrumbs],
      content: {
        data: {},
        content: props.content.content,
        nodeType: 'document',
      },
      keyTakeaways: keyTakeaways.length
        ? keyTakeaways.split('\n').filter((item) => item.length)
        : [],
      faq:
        props.faq?.map(({ fields }) => ({
          title: fields.question,
          content: fields.answer,
        })) || [],
      // eslint-disable-next-line react/prop-types,react/destructuring-assignment

      modifiedDate: page.updatedAt,
      dateCreated: props.createdAt,
      author: {
        // eslint-disable-next-line react/prop-types,react/destructuring-assignment
        fullName: props.author?.fullName,
        // eslint-disable-next-line react/prop-types,react/destructuring-assignment
        url: `/author/${props.author?.slug}`,
        description: props.author?.description,
        socialMedia: [
          props.author?.facebook,
          props.author?.twitter,
          props.author?.linkedIn,
          props.author?.webPage,
        ],
        image: props.author?.avatar,
      },
    }

    return <Component {...componentProps} />
  }
}
